import * as React from 'react';
import './ImagePreview.css';
import { useSelector, useDispatch } from 'react-redux'
import { Image } from 'react-bootstrap';
import { MONTHLY_MILEAGE, DASHBOARD, PERSONAL_INSURANCE, SELF_INSPECTION, CAPTURE_IMAGES, CLAIMS_DETAILS, FNOL_SUBMIT_CLAIM } from '../../routes/routes';
import { showClaimsV2StepsScreen, showFNOLStepsScreen, showPhotoStepsScreen, showSelfInspectStepsScreen } from '../../actions/fullscreenActions';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { navigateTo } from '../../actions/navigationActions';
import { savePhoto } from '../../actions/selfInspectActions';
import { saveClaimV2Photo, saveFnolPhoto } from '../../actions/claimSubmitActions';

export const ImagePreview = () => {

    const dispatch = useDispatch();
    let cameraState = useSelector(state => state.camera);
    let profileState = useSelector(state => state.profile);
    let claimState = useSelector(state => state.claimSubmit);
    let selfInspectState = useSelector(state => state.selfInspect);

    let photo = "";
    let activePage = "";
    let header = <>
        <div className="container text-center pt-3">
            <h3 className="Step-Header mb-1">{cameraState.dashboardHeader}</h3>
            <p className="Step-Description">{cameraState.dashboardDescription}</p>
        </div>
    </>

    if (profileState.selfInspectionStep === 1) {
        activePage = "Dashboard photo"
        photo = cameraState.dashboardPhotoData
    }
    else if (profileState.selfInspectionStep === 2) {
        activePage = "Mileage photo"
        photo = cameraState.mileagePhotoData
        header = <>
            <div className="container text-center pt-3">
                <h3 className="Step-Header mb-1">{cameraState.mileageHeader}</h3>
                <p className="Step-Description">{cameraState.mileageDescription}</p>
            </div>
        </>
    } if (typeof profileState.selfInspectionStep === 'string') {
        photo = cameraState.selfInspectPhotoData;
    } else {
        photo = cameraState.selfInspectPhotoData;
    }

    async function handleRetakePhoto(screen) {
        if (screen === "mileage") {
            dispatch(showPhotoStepsScreen());
        } else if (screen === "selfinspection") {
            dispatch(showSelfInspectStepsScreen());
        }
    }

    async function handleNextInspection() {
        await dispatch(savePhoto(profileState.selfInspectionStep.toUpperCase(), cameraState.selfInspectPhotoData, cameraState.selfInspectLat, cameraState.selfInspectLon))

        dispatch(navigateTo(CAPTURE_IMAGES));
    }

    async function handleNextFNOL() {
        await dispatch(saveFnolPhoto(claimState.selectedDamagePhotoTypes.description.toLowerCase(), cameraState.selfInspectPhotoData))
        dispatch(navigateTo(FNOL_SUBMIT_CLAIM));
    }

    async function handleNextClaimsV2() {
        await dispatch(saveClaimV2Photo(claimState.selectedDamagePhotoTypes.description.toLowerCase(), cameraState.selfInspectPhotoData))
        //dispatch(navigateTo(CLAIMSV2_SUBMIT_CLAIM));
        dispatch(navigateTo(FNOL_SUBMIT_CLAIM));
    }

    function handleRetakeFnol() {
        dispatch(showFNOLStepsScreen());
    }

    function handleRetakeClaimsV2() {
        dispatch(showClaimsV2StepsScreen());
    }


    function handleNext() {
        dispatch(navigateTo(MONTHLY_MILEAGE));
    }

    let product = "car"
    let BreadcrumbDetailsChilli = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Chilli" }]

    let BreadcrumbDetailsSelfInspect = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Car" }]
    if (selfInspectState.selectedPersonalCover.product === 7) {
        BreadcrumbDetailsSelfInspect = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Motorbike" }]
        product = "motorbike"
    }
    const isSelfInspection = typeof profileState.selfInspectionStep === 'string';
    const isFNOL = claimState.selectedDamagePhotoTypes.length !== 0;
    const isClaimsV2 = claimState.selectedDamagePhotoTypes.length !== 0;

    var captureMilage = <div id="ImagePreview">
        <KPBreadCrumb navList={BreadcrumbDetailsChilli} activePage={activePage} />
        <div id="ImagePreview" className="box mt-0">
            <div className="text-center">
                {header}
                <div>
                    <Image id="Preview-img" src={photo} className="pl-2 pr-2" />
                </div>
                <div className="text-center pt-3">
                    <p><b>{activePage}</b></p>
                </div>
            </div>
            <div id="PhotoSubmission" className="text-center pb-4">
                <button id="btnRetakePhoto" className="btn btn-outline-red mr-lg-2 mb-lg-0 mr-2 mb-2" onClick={() => handleRetakePhoto("mileage")}>Retake photo</button>
                <button id="btnNext" className="btn btn-solid-red mr-2 mb-2" onClick={handleNext}>Next step</button>
            </div>
        </div>
    </div>

    /// SELF INSPECTION SECTION ///
    /* /// Sample image for testing: large /// */
    /*photo = "./Images/SelfInspect/self-inspect-sample-photo-large-new.jpg";*/

    let BreadcrumbDetailsSelfInspection = [{ destination: DASHBOARD, description: "Home" }, { destination: SELF_INSPECTION, description: "Self Inspection" }, { destination: CAPTURE_IMAGES, description: "Snap a photo" }]
    activePage = "Here's your photo"

    var captureSelfInspection = <div className="container-fluid selfinspect-image-preview-container">
        <div className="new-breadcrumbwrapper breadcrumb-wrapper-capture-images">
            <KPBreadCrumb navList={BreadcrumbDetailsSelfInspection} activePage={activePage} />
        </div>
        <div className="selfinspect-image-preview-actual-image-holder">
            <Image id="Preview-img" src={photo} className="pl-2 pr-2" />
            <div className="selfinspect-image-preview-sample-text">
                <div>
                    <span>
                        Image loading. Please wait...
                        <br />
                        If this does not change to your actual photo, please retake.
                    </span>
                </div>
            </div>
            <div className="selfinspect-image-preview-target-brackets">
                <div className="selfinspect-image-preview-bracket-tl"></div>
                <div className="selfinspect-image-preview-bracket-tr"></div>
                <div className="selfinspect-image-preview-bracket-bl"></div>
                <div className="selfinspect-image-preview-bracket-br"></div>
            </div>
        </div>
        <div id="SelfInspectImagePreview" className="box selfinspect-instructionbox">
            <h3 className="Step-Header mt-">Here's your photo</h3>
            <p className="Step-Description">Remember that 90% of your {product} needs to fit into the guidelines shown on the image</p>
            <p className="Step-Description-retake">You can choose to retake the photo or submit it as is</p>

            <div className="row selfinspect-instructionbox-buttonrow">
                <div className="col">
                    <button className="btn btn-block btn-outline-red w-100" type="button" id="RetakePhoto" onClick={() => handleRetakePhoto("selfinspection")}>Retake photo</button>
                </div>
                <div className="col">
                    <button className="btn btn-block btn-solid-red w-100" type="button" id="Submit" onClick={() => handleNextInspection()}>Submit</button>
                </div>
            </div>
        </div>
    </div>
    /// END SELF INSPECTION SECTION ///

    let BreadcrumbDetailsFNOL = [{ destination: DASHBOARD, description: "Home" }, { destination: CLAIMS_DETAILS, description: "Submit a claim" }, { destination: CAPTURE_IMAGES, description: "Snap a photo" }]

    let BreadcrumbDetailsClaimsV2 = [{ destination: DASHBOARD, description: "Home" }, { destination: CLAIMS_DETAILS, description: "Submit a claim" }, { destination: CAPTURE_IMAGES, description: "Snap a photo" }]
    activePage = "Here's your photo"
    var captureFNOL =
        <div className="container-fluid selfinspect-image-preview-container">
            <div className="new-breadcrumbwrapper breadcrumb-wrapper-capture-images">
                <KPBreadCrumb navList={BreadcrumbDetailsFNOL} activePage={activePage} />
            </div>
            <div className="selfinspect-image-preview-actual-image-holder">
                <Image id="Preview-img" src={photo} className="pl-2 pr-2" />
                <div className="selfinspect-image-preview-sample-text">
                    <div>
                        <span>
                            Image loading. Please wait...
                        <br />
                        If this does not change to your actual photo, please retake.
                    </span>
                    </div>
                </div>
                <div className="selfinspect-image-preview-target-brackets">
                    <div className="selfinspect-image-preview-bracket-tl"></div>
                    <div className="selfinspect-image-preview-bracket-tr"></div>
                    <div className="selfinspect-image-preview-bracket-bl"></div>
                    <div className="selfinspect-image-preview-bracket-br"></div>
                </div>
            </div>
            <div id="SelfInspectImagePreview" className="box selfinspect-instructionbox">
                <h3 className="Step-Header mt-">Here's your photo</h3>
                <p className="Step-Description">Remember that 90% of your damages needs to fit into the guidelines shown on the image</p>
                <p className="Step-Description-retake">You can choose to retake the photo or submit it as is</p>

                <div className="row selfinspect-instructionbox-buttonrow">
                    <div className="col">
                        <button className="btn btn-block btn-outline-red w-100" type="button" id="RetakePhoto" onClick={() => handleRetakeFnol()}>Retake photo</button>
                    </div>
                    <div className="col">
                        <button className="btn btn-block btn-solid-red w-100" type="button" id="Submit" onClick={() => handleNextFNOL()}>Submit</button>
                    </div>
                </div>
            </div>
        </div>



    //Claims V2
    var captureClaimsV2 =
        <div className="container-fluid selfinspect-image-preview-container">
            <div className="new-breadcrumbwrapper breadcrumb-wrapper-capture-images">
                <KPBreadCrumb navList={BreadcrumbDetailsClaimsV2} activePage={activePage} />
            </div>
            <div className="selfinspect-image-preview-actual-image-holder">
                <Image id="Preview-img" src={photo} className="pl-2 pr-2" />
                <div className="selfinspect-image-preview-sample-text">
                    <div>
                        <span>
                            Image loading. Please wait...
                        <br />
                        If this does not change to your actual photo, please retake.
                    </span>
                    </div>
                </div>
                <div className="selfinspect-image-preview-target-brackets">
                    <div className="selfinspect-image-preview-bracket-tl"></div>
                    <div className="selfinspect-image-preview-bracket-tr"></div>
                    <div className="selfinspect-image-preview-bracket-bl"></div>
                    <div className="selfinspect-image-preview-bracket-br"></div>
                </div>
            </div>
            <div id="SelfInspectImagePreview" className="box selfinspect-instructionbox">
                <h3 className="Step-Header mt-">Here's your photo</h3>
                <p className="Step-Description">Remember that 90% of your damages needs to fit into the guidelines shown on the image</p>
                <p className="Step-Description-retake">You can choose to retake the photo or submit it as is</p>

                <div className="row selfinspect-instructionbox-buttonrow">
                    <div className="col">
                        <button className="btn btn-block btn-outline-red w-100" type="button" id="RetakePhoto" onClick={() => handleRetakeFnol()}>Retake photo</button>
                    </div>
                    <div className="col">
                        <button className="btn btn-block btn-solid-red w-100" type="button" id="Submit" onClick={() => handleNextClaimsV2()}>Submit</button>
                    </div>
                </div>
            </div>
        </div>


    //End Claims V2

    if (isFNOL) {
        return captureFNOL
    } else
        if (isSelfInspection) {
            return captureSelfInspection
    }
    else if (isClaimsV2) {
            return captureClaimsV2
        
    } else {
        return captureMilage
    }
};

export default ImagePreview;